/**
 * Layout wrapper for /analyze/* — registry access, public guest flow allowed.
 */

import { Outlet } from 'react-router-dom'
import { AppRoute } from '@/components/routing/AppRoute'

export function AnalyzerRouteLayout() {
  return (
    <AppRoute routeId="analyzer">
      <Outlet />
    </AppRoute>
  )
}
